import { checkinApi } from '@/services/api/httpClient';

const actions = {
  async getExamsCategories({ getters, commit }) {
    const medicalOrders = getters.getCurrentAdmissionState.data?.medicalOrders;
    if (medicalOrders) {
      const exams = getExamsCodeByMedicalOrders(medicalOrders[0]);
      const response = await checkinApi().get('/exam/search', {
        params: {
          products: exams.join(','),
          brandId: getters.getBrandUnitIdVariables.brandId,
          page: 0,
          sizeSearch: exams.length,
          includeSuspense: true,
        },
      });

      const examsHaveSameCategory = response.data.length
        ? haveAllExamsSameCategory(response.data)
        : false;

      commit('SET_HAVE_ALL_EXAMS_SAME_CATEGORY', examsHaveSameCategory);
      commit('SET_DETAILED_EXAMS_LIST', response.data);

      return response.data ? response.data : [];
    }
    return [];
  },

  async getDataProviderExamsCategories({ getters }, { exams = [] }) {
    return await checkinApi().get('/exam/search', {
      params: {
        products: exams.join(','),
        brandId: getters.getBrandUnitIdVariables.brandId,
        page: 0,
        sizeSearch: exams.length,
        includeSuspense: true,
      },
    });
  },

  async searchExamsAPI(_, params) {
    const url = '/exam/search';

    const resp = await checkinApi().get(url, { params });

    return resp.data;
  },
};

export default actions;

const getExamsCodeByMedicalOrders = (medicalOrders) => {
  if (medicalOrders.exams) {
    return medicalOrders.exams.map((exam) => exam.examCode);
  }
  return [];
};

const haveAllExamsSameCategory = (examsList) => {
  const firstExamCategoryId = examsList[0].category.id;

  const haveAllSameCategory = examsList.every((exam) => {
    return exam.category.id === firstExamCategoryId;
  });

  return haveAllSameCategory;
};
